import produce from 'immer';
import { create } from 'zustand';

type HttpState = {
  errors: { [service: string]: { timestamp: Date; message: string }[] };
  openRequests: { [service: string]: number };

  start: (service: string) => void;
  stop: (service: string) => void;
  error: (service: string, error: string) => void;
  clear: () => void;
};

export const HTTP_STORE = create<HttpState>((set) => ({
  errors: {},
  openRequests: {},

  start: (service: string) =>
    set((state) => {
      const newState = produce(state, (draft) => {
        if (state.openRequests[service] === undefined) {
          draft.openRequests[service] = 1;
        } else {
          draft.openRequests[service] = state.openRequests[service] + 1;
        }
      });

      return newState;
    }),
  stop: (service: string) =>
    set((state) => {
      const newState = produce(state, (draft) => {
        draft.openRequests[service] = draft.openRequests[service] - 1;
      });

      return newState;
    }),
  error: (service: string, message: string) =>
    set((state) => {
      const newState = produce(state, (draft) => {
        if (draft.errors[service] === undefined) {
          draft.errors[service] = [{ timestamp: new Date(), message: message }];
        } else {
          draft.errors[service].push({ timestamp: new Date(), message: message });
        }
        draft.openRequests[service] = draft.openRequests[service] - 1;
      });

      return newState;
    }),
  clear: () =>
    set((state) => {
      const newState = produce(state, (draft) => {
        draft.errors = {};
        draft.openRequests = {};
      });

      return newState;
    })
}));
